var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('v-row',{staticClass:"mx-0 mb-1",attrs:{"justify":_vm.admin ? 'space-between' : 'end'}},[(_vm.admin)?_c('delete-button',{attrs:{"quiet":"","headline":"Delete Program page?","ondelete":_vm.deletePage}}):_vm._e(),_c('save-button',{attrs:{"onsave":_vm.savePage}})],1),_c('v-row',[_c('v-col',[_c('ProgramPageInfo')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }